var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14.5H4.66667M14 4V5.16667M23.3333 14.5H24.5M6.53333 7.03333L7.35 7.85M21.4667 7.03333L20.65 7.85M10.5 19.1667C9.52055 18.4321 8.79706 17.4079 8.432 16.2393C8.06695 15.0707 8.07885 13.8168 8.46601 12.6553C8.85318 11.4939 9.59597 10.4836 10.5892 9.76775C11.5824 9.05188 12.7757 8.66667 14 8.66667C15.2243 8.66667 16.4176 9.05188 17.4108 9.76775C18.404 10.4836 19.1468 11.4939 19.534 12.6553C19.9211 13.8168 19.933 15.0707 19.568 16.2393C19.2029 17.4079 18.4795 18.4321 17.5 19.1667C17.0445 19.6176 16.7015 20.1694 16.4988 20.7774C16.2962 21.3854 16.2395 22.0326 16.3333 22.6667C16.3333 23.2855 16.0875 23.879 15.6499 24.3166C15.2123 24.7542 14.6188 25 14 25C13.3812 25 12.7877 24.7542 12.3501 24.3166C11.9125 23.879 11.6667 23.2855 11.6667 22.6667C11.7605 22.0326 11.7038 21.3854 11.5011 20.7774C11.2985 20.1694 10.9555 19.6176 10.5 19.1667M11.3167 20.3333H16.6833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRBulb);
export default __webpack_public_path__ + "static/media/r_bulb.81146aa24a5b730c39ed8d2249b0af66.svg";
export { ForwardRef as ReactComponent };